import { useEffect, useState } from "react";

import { Outlet } from "react-router-dom";
import ExamMenu from "./components/menubar";
import NotificationToasts from "../leads/components/NotificationToast";
import Footer1 from "../components/footer/footer1";
import MenuBar from "./components/menubar";

const Examination = () => {
    const [notifications, setNotifications] = useState([]);

    useEffect(() => {
        if ("serviceWorker" in navigator) {
          navigator.serviceWorker.addEventListener("message", (event) => {
            setNotifications((prev) => [
              ...prev,
              { ...event.data, timestamp: new Date().toLocaleTimeString() },
            ]);
          });
        }
    }, []);

    const removeNotification = (index) => {
        setNotifications((prev) => prev.filter((_, i) => i !== index));
      };
    
    return (
      <div>
        <div className="main_container">
            <MenuBar />
            <NotificationToasts
            notifications={notifications}
            removeNotification={removeNotification}
            />
            <Outlet />
            <Footer1 />
        </div>
      </div>
    );
}

export default Examination;